import { WarningIcon } from '@src/shared/ui/icons';
import { Box } from '@src/shared/ui/layout';
import Typography from '@src/shared/ui/Typography';
import { StyleSheet } from './FormHeader.styles';

type FormHeaderProps = {
  tone: 'warning' | 'error';
  message: string;
};

export default function FormHeader({ tone, message }: FormHeaderProps) {
  return (
    <Box sx={StyleSheet.container(tone)}>
      <WarningIcon sx={StyleSheet.icon(tone)} />
      <Typography variant="h6" sx={StyleSheet.message(tone)}>
        {message}
      </Typography>
    </Box>
  );
}
